module.exports = __webpack_public_path__ + "static/img/annualMajorEvent2.dcdb201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/annualMajorEvent2.png
// module id = 5+RX
// module chunks = 1